import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const createIdentityReview = createAsyncThunk(
  'reviewIdentity/createIdentityReview',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/identity-review`,
        { ...payload },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
